import Big from 'big.js';
import { standardCollator } from 'js/utils/string';

// Capability positions are decimal strings between 0 and 1, ordered among
// siblings. Capabilities without a position sort after those with one, by name.

// Assessment documents cache capabilities under this key instead, because the
// document schema reserves `position` for its own ordering
export const CACHED_POSITION_KEY = 'capabilityPosition';

export function parsePosition(position) {
  if (position == null || position === '') {
    return null;
  }

  try {
    return Big(position);
  } catch {
    return null;
  }
}

export function compareCapabilities(
  collator = standardCollator,
  positionKey = 'position'
) {
  return (a, b) => {
    const positionA = parsePosition(a[positionKey]);
    const positionB = parsePosition(b[positionKey]);

    if (positionA && positionB) {
      const cmp = positionA.cmp(positionB);
      if (cmp !== 0) {
        return cmp;
      }
    } else if (positionA) {
      return -1;
    } else if (positionB) {
      return 1;
    }

    return (
      collator.compare(a.name, b.name) ||
      collator.compare(a.id ?? a.guid, b.id ?? b.guid)
    );
  };
}

export function sortCapabilities(
  capabilities,
  collator = standardCollator,
  positionKey = 'position'
) {
  return [...(capabilities ?? [])].sort(
    compareCapabilities(collator, positionKey)
  );
}

/** Orders capabilities cached in an assessment document. */
export const compareCachedCapabilities = compareCapabilities(
  standardCollator,
  CACHED_POSITION_KEY
);
